import { createContext, useContext } from 'react';

export interface DashboardAccessContextValue {
  isUserDashboard: boolean;
  accessibleModuleIds: Set<string>;
  accessibleAgendaIds: Set<string>;
}

const DEFAULT_DASHBOARD_ACCESS: DashboardAccessContextValue = {
  isUserDashboard: false,
  accessibleModuleIds: new Set(),
  accessibleAgendaIds: new Set(),
};

export const DashboardAccessContext = createContext<DashboardAccessContextValue>(DEFAULT_DASHBOARD_ACCESS);

export const useDashboardAccess = () => useContext(DashboardAccessContext);
